import * as React from 'react';
import {useState} from 'react';
import Box from "@material-ui/core/Box";
import {connect} from "react-redux"
import {Button, Container, createStyles, Grid, makeStyles, TextField, Theme} from "@material-ui/core";
import {ApplicationState} from "../../redux/reducers";
import {ICliente} from "../../entities/catalogos/ICliente";
import {Solicitud} from "../../entities/solicitudes/Solicitud";
import {IUsuario} from '../../entities/catalogos/IUsuario';
import {Add, Search} from '@material-ui/icons';
import AgregarFacturador from './AgregarFacturador';
import BuscarFacturador from './BuscarFacturador';
import { useHistory } from "react-router-dom";
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { enums } from '../../enums/enums';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            minHeight: "300px",
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            paddingTop: "40px",
            paddingLeft: "40px"
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            paddingTop: "30px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        }
    }),
);


interface OwnProps {
    siguienteSeccion: (siguienteSeccionId: number, datosSeccion: any, cotizacion_ID?: number, contacto?: any, datosRemitente?: any, datosDestinatario?: any, proyecto?: any, facturador?: any) => void
    cotizacionId: number
}

interface StateProps {
    cliente: ICliente
    solicitud: Solicitud
    solicitudCopia: Solicitud
    usuario: IUsuario
    ayuda: IHelp
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia

}

type Props = OwnProps & StateProps & DispatchProps

const Facturador = (props: Props) => {
    let newFacturador = { id: 0, clienteNombre: "", clienteRFC: "" };
    if(props.solicitud?.facturador !== null && props.solicitud?.facturador !== undefined)
        newFacturador={
            id: props.solicitud?.facturador?.id,
            clienteNombre:  props.solicitud?.facturador.clienteNombre,
            clienteRFC: props.solicitud?.facturador.clienteRFC
    }

    const classes = useStyles();
    const [buscaFacturador, setBuscarFacturador] = useState(false);
    const [agregaFacturador, setAgregarFacturador] = useState(false);
    const [facturador, setFacturador] = useState(newFacturador);

    const cerrarBusquedaFacturador = () => {
        setBuscarFacturador(false);
    };

    const cerrarNuevoFacturador = () => {
        setAgregarFacturador(false);
    };

    const buscarFacturador = () => {
        setBuscarFacturador(true);
    };

    const agregarFacturador = () => {
        setBuscarFacturador(false);
        setAgregarFacturador(true);
    };

    const configurarProyecto = () => {
        props.siguienteSeccion(enums.estatusSolicitud.origenDestino, null, 0, null, null, null, null, facturador);
    }

    const getFacturador = (clienteFacturador: any) => {
        setFacturador(clienteFacturador);
    }

    return (<>
        <div style={{width: '90%', margin: 'auto', marginTop: '1em'}}>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Container maxWidth="xl" className={classes.principal}>
                        <Box>
                            <Help comments={traducirMessage(56)} customStyle={{ top: "-25px",right: "-55px" }} />
                        </Box>

                        <Box display="flex" justifyContent="center" mt={2} className="title">
                            {/* Datos del Facturador */
                            traducirLabel(73)}
                        </Box>

                        <Grid container spacing={3} className={classes.container}>
                            <Grid item xs={12}>
                                <div className={classes.label}>
                                    {/* Necesita agregar un Facturador para su Servicio (opcional) */
                                    traducirMessage(190)}
                                </div>
                            </Grid>
                            <Grid item xs={10}>
                                <div className={classes.div_rfc}>
                                    <form className={classes.root} noValidate autoComplete="off">
                                        <TextField id="outlined-basic" label="" variant="outlined" fullWidth
                                                   disabled={true}
                                                   // value={props.solicitud.facturador != undefined
                                                   // && props.solicitud.facturador.clienteRFC !== ""
                                                   //     && props.solicitud.facturador.clienteRFC !== undefined
                                                   //     && props.solicitud.facturador.clienteRFC !== null ? props.solicitud.facturador.clienteRFC : facturador.clienteRFC}

                                                   value={
                                                      facturador != undefined
                                                   && facturador.clienteRFC !== ""
                                                   && facturador.clienteRFC !== undefined
                                                   && facturador.clienteRFC !== null ? facturador.clienteRFC : props?.solicitud?.facturador?.clienteRFC}
                                        />
                                    </form>

                                </div>
                            </Grid>
                            <Grid item xs={1}>
                                <Button className={classes.icon} variant="contained" color="primary"
                                        onClick={() => buscarFacturador()}>
                                    <Search/>
                                </Button>
                            </Grid>
                            <Grid item xs={1}>
                                <Button className={classes.icon} variant="contained" color="primary"
                                        onClick={() => agregarFacturador()}>
                                    <Add/>
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>

                    <Grid container className={classes.actions}>
                        <Grid item xs={12} style={{textAlign: "right"}}>
                            <Button variant="contained" color="primary" onClick={() => configurarProyecto()}>
                                {!facturador.clienteRFC? traducirButton(18) : traducirButton(7)}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {buscaFacturador &&
            <>
                <BuscarFacturador abierto={buscaFacturador} cerrar={cerrarBusquedaFacturador} ayuda={props.ayuda}
                                  confirmar={cerrarBusquedaFacturador} setFacturador={getFacturador}
                                  idCliente={props.cliente.id} usuario={props.usuario.nombre} empresaId={props.cliente.empresaID}/>
            </>
            }

            {agregaFacturador &&
            <>
                <AgregarFacturador abierto={agregaFacturador} cerrar={cerrarNuevoFacturador} ayuda={props.ayuda}
                                   confirmar={cerrarNuevoFacturador} setFacturador={getFacturador}
                                    clienteId={props.cliente.id} usuario={props.usuario.nombre} empresaId={props.cliente.empresaID}/>
            </>
            }

        </div>
    </>)


};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
};


export default connect(mapStateToProps, mapDispatchToProps)(Facturador);
